// removed by extract-text-webpack-plugin
module.exports = {"skFoldingCube":"Spinner__skFoldingCube__30aOW","skCube":"Spinner__skCube__3JmzR","skFoldCubeAngle":"Spinner__skFoldCubeAngle__2jEAR","skCube2":"Spinner__skCube2__3_pVz","skCube3":"Spinner__skCube3__2EE5d","skCube4":"Spinner__skCube4__2QTm2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CommonComponents/Spinner/Spinner.css
// module id = 119
// module chunks = 0